import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\PackageController::store
* @see app/Http/Controllers/Admin/PackageController.php:54
* @route '/app/admin/packages'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/admin/packages',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PackageController::store
* @see app/Http/Controllers/Admin/PackageController.php:54
* @route '/app/admin/packages'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PackageController::store
* @see app/Http/Controllers/Admin/PackageController.php:54
* @route '/app/admin/packages'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::store
* @see app/Http/Controllers/Admin/PackageController.php:54
* @route '/app/admin/packages'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::store
* @see app/Http/Controllers/Admin/PackageController.php:54
* @route '/app/admin/packages'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\PackageController::reorder
* @see app/Http/Controllers/Admin/PackageController.php:201
* @route '/app/admin/packages/reorder'
*/
export const reorder = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: reorder.url(options),
    method: 'put',
})

reorder.definition = {
    methods: ["put"],
    url: '/app/admin/packages/reorder',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\PackageController::reorder
* @see app/Http/Controllers/Admin/PackageController.php:201
* @route '/app/admin/packages/reorder'
*/
reorder.url = (options?: RouteQueryOptions) => {
    return reorder.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PackageController::reorder
* @see app/Http/Controllers/Admin/PackageController.php:201
* @route '/app/admin/packages/reorder'
*/
reorder.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: reorder.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::reorder
* @see app/Http/Controllers/Admin/PackageController.php:201
* @route '/app/admin/packages/reorder'
*/
const reorderForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::reorder
* @see app/Http/Controllers/Admin/PackageController.php:201
* @route '/app/admin/packages/reorder'
*/
reorderForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

reorder.form = reorderForm

/**
* @see \App\Http\Controllers\Admin\PackageController::update
* @see app/Http/Controllers/Admin/PackageController.php:80
* @route '/app/admin/packages/{package}'
*/
export const update = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/admin/packages/{package}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\PackageController::update
* @see app/Http/Controllers/Admin/PackageController.php:80
* @route '/app/admin/packages/{package}'
*/
update.url = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { package: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { package: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            package: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        package: typeof args.package === 'object'
        ? args.package.id
        : args.package,
    }

    return update.definition.url
            .replace('{package}', parsedArgs.package.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PackageController::update
* @see app/Http/Controllers/Admin/PackageController.php:80
* @route '/app/admin/packages/{package}'
*/
update.put = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::update
* @see app/Http/Controllers/Admin/PackageController.php:80
* @route '/app/admin/packages/{package}'
*/
const updateForm = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::update
* @see app/Http/Controllers/Admin/PackageController.php:80
* @route '/app/admin/packages/{package}'
*/
updateForm.put = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\PackageController::destroy
* @see app/Http/Controllers/Admin/PackageController.php:215
* @route '/app/admin/packages/{package}'
*/
export const destroy = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/admin/packages/{package}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\PackageController::destroy
* @see app/Http/Controllers/Admin/PackageController.php:215
* @route '/app/admin/packages/{package}'
*/
destroy.url = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { package: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { package: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            package: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        package: typeof args.package === 'object'
        ? args.package.id
        : args.package,
    }

    return destroy.definition.url
            .replace('{package}', parsedArgs.package.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PackageController::destroy
* @see app/Http/Controllers/Admin/PackageController.php:215
* @route '/app/admin/packages/{package}'
*/
destroy.delete = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::destroy
* @see app/Http/Controllers/Admin/PackageController.php:215
* @route '/app/admin/packages/{package}'
*/
const destroyForm = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::destroy
* @see app/Http/Controllers/Admin/PackageController.php:215
* @route '/app/admin/packages/{package}'
*/
destroyForm.delete = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\PackageController::cancelPriceChange
* @see app/Http/Controllers/Admin/PackageController.php:170
* @route '/app/admin/packages/{package}/price-change'
*/
export const cancelPriceChange = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: cancelPriceChange.url(args, options),
    method: 'delete',
})

cancelPriceChange.definition = {
    methods: ["delete"],
    url: '/app/admin/packages/{package}/price-change',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\PackageController::cancelPriceChange
* @see app/Http/Controllers/Admin/PackageController.php:170
* @route '/app/admin/packages/{package}/price-change'
*/
cancelPriceChange.url = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { package: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { package: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            package: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        package: typeof args.package === 'object'
        ? args.package.id
        : args.package,
    }

    return cancelPriceChange.definition.url
            .replace('{package}', parsedArgs.package.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PackageController::cancelPriceChange
* @see app/Http/Controllers/Admin/PackageController.php:170
* @route '/app/admin/packages/{package}/price-change'
*/
cancelPriceChange.delete = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: cancelPriceChange.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::cancelPriceChange
* @see app/Http/Controllers/Admin/PackageController.php:170
* @route '/app/admin/packages/{package}/price-change'
*/
const cancelPriceChangeForm = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancelPriceChange.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::cancelPriceChange
* @see app/Http/Controllers/Admin/PackageController.php:170
* @route '/app/admin/packages/{package}/price-change'
*/
cancelPriceChangeForm.delete = (args: { package: number | { id: number } } | [packageParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancelPriceChange.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

cancelPriceChange.form = cancelPriceChangeForm

const packages = {
    store: Object.assign(store, store),
    reorder: Object.assign(reorder, reorder),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    cancelPriceChange: Object.assign(cancelPriceChange, cancelPriceChange),
}

export default packages